<template>
  <div class="checkin-step1">
    <div class="checkin-form-wrap clearfix">
      <div class="form-wrap">
        <checkin-form @callback="checkIn" :idInfo="idInfo" :checkinReferArticles="cmsData.checkinReferArticles" :hasPhoneField="true"></checkin-form>
      </div>
      <div class="code-wrap" v-if="cmsData.checkinQRcode && cmsData.checkinQRcode.content" v-html="cmsData.checkinQRcode.content"></div>
    </div>
    <div class="rule-wrap">
      <rule :checkinTips="cmsData.checkinTips"></rule>
    </div>
  </div>
</template>
<script>
import CheckinForm from '@/components/checkin/checkinForm'
import Rule from '@/components/checkin/rule'
export default {
  components: {
    CheckinForm,
    Rule
  },
  props: {
    idInfo: Object,
    cmsData: Object
  },
  methods: {
    checkIn (data) {
      this.$emit('callback', 2, data, data)
      window.__MICRO_ROOT__?.api?.track?.('checkin_click')
    }
  }
}
</script>
<style lang="less" scoped>
.checkin-step1 {
  .checkin-form-wrap {
    width: 640px;
    margin: 0 auto;
    display: flex;
    justify-content: center;
  }
  .form-wrap {
    width: 388px;
  }
  .code-wrap {
    width: 190px;
    margin-left: 60px;
    img {
      width: 190px;
      height: 217px;
    }
    .text {
      text-align: center;
      font-size: 12px;
      line-height: 1;
      color: #808080;
      margin-top: 20px;
    }
  }
  .rule-wrap {
    margin-top: 50px;
  }
}
@media only screen and (max-width: 768px) {
  .checkin-step1 {
    .form-wrap {
      width: 100%;
      float: none;
    }
    .code-wrap {
      float: none;
      margin: 0 auto;
    }
    .checkin-form-wrap {
      width: 96%;
    }
    .rule-wrap {
      width: 94%;
      margin: 0 auto;
      margin-top: 30px;
    }
  }
}
</style>
